import React from 'react';
import { NavLink } from 'react-router-dom';
import { Container, Row, Button } from 'react-bootstrap';
import bg1 from '../../../images/bg5.png';
import bg2 from '../../../images/bg3.png';
import bg3 from '../../../images/bg1.png';
import bg4 from '../../../images/bg6.png';

const HomeRecordLabel = () => {
  return (
    <Container className='HomeRecordLabel' fluid>
      <Container fluid>
        <Row className='HomeRecordLabel_heading1'>Record</Row>
        <Row className='HomeRecordLabel_heading2'>Label</Row>
        <div>
          <Row className='HomeRecordLabel_row'>
            <li>
              <img src={bg1} alt='' width='100%' height='100%' />
            </li>
            <li>
              <img src={bg2} alt='' width='100%' height='100%' />
            </li>
            <li>
              <img src={bg3} alt='' width='100%' height='100%' />
            </li>
            <li>
              <img src={bg4} alt='' width='100%' height='100%' />
            </li>
            {/* <li>
              <img src={bg5} alt='' width='100%' height='100%' />
            </li> */}
          </Row>
          <Row className='HomeRecordLabel-content'>
            <p>
              Led by a free spirit and dedication to unique productions, our
              record label is home to emerging electronic music sounds & artists
            </p>
          </Row>
          <NavLink to='/recordLabel'>
            <Button className='btn HomeRecordLabel-btn'>Explore</Button>
          </NavLink>
        </div>
      </Container>
    </Container>
  );
};
export default HomeRecordLabel;
